"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var maxLength = function maxLength(maximumLength) {
  return {
    fn: function fn(value) {
      return value.length > maximumLength;
    },
    errorMessageId: 'forms.error.maxLength'
  };
};

var _default = maxLength;
exports["default"] = _default;